import CityStateField from './CityStateField';

const CityStateFormWrapper = (props) => {
  const { addressArray, schema, requiredFields } = props;
  if (addressArray.length === 0) {
    return null;
  }
  if (addressArray.length === 1) {
    return (
      <>
        {addressArray.map((element) => (
          <CityStateField
            element={element}
            schema={schema}
            key={element}
            requiredFields={requiredFields}
          />
        ))}
      </>
    );
  }
  return (
    <div className="c7-form__group">
      {addressArray.map((element) => (
        <CityStateField
          element={element}
          schema={schema}
          key={element}
          requiredFields={requiredFields}
        />
      ))}
    </div>
  );
};

export default CityStateFormWrapper;
